// extracted by mini-css-extract-plugin
export default {"fieldset":"TextInput_fieldset__Hj77g","fieldset__legend":"TextInput_fieldset__legend__GTL2L","fieldset__input":"TextInput_fieldset__input__AvxUh"};